import { childElements, getElementById, moveAllChildren } from "../util/Utils";
import { localNavigation } from "./Selectors";
import { setLegacyLabels } from "../tracking/FeatureTracking";
import { eventQBus } from "../types/EventQBus";
import { sheetV1 } from "@otto-ec/otto-components/sheet";

export const LOCAL_NAVIGATION = "localNavigation";
const FILTER_DETAIL_SHEET_ID = "heureka-localnavigationsheet";
const FILTER_DETAIL_SHEET_CONTENT_CLASS = "heureka_filterDetailSheet__content";
const FILTER_DETAIL_SHEET_CONTENT_SELECTOR = `.${FILTER_DETAIL_SHEET_CONTENT_CLASS}`;

export default class OcFilterNavigationSheet {
  /*               */

  constructor(
    private readonly sheet: sheetV1 | undefined = getElementById(FILTER_DETAIL_SHEET_ID),
    private readonly sheetContent: HTMLElement | null | undefined = sheet?.querySelector(
      FILTER_DETAIL_SHEET_CONTENT_SELECTOR,
    ),
  ) {
    if (this.sheet) {
      this.sheet.headline = "Kategorien";
    }
  }

  public static declare() {
    return new OcFilterNavigationSheet();
  }

  setSheet() {
    if (this.sheetContent) {
      this.sheetContent.append(...childElements(localNavigation()));
    }
    return this;
  }

  initializeSheet() {
    if (this.sheet) {
      this.sheet.open = true;
      this.sheet?.addEventListener("oc-sheet-before-close", this.onClose);
    }

    if (this.sheetContent) {
      OcFilterNavigationSheet.prepareContent(this.sheetContent);
    }
    return this;
  }

  public open() {
    if (this.sheet) {
      this.sheet.open();
    }
    return this;
  }

  public deactivate() {
    const source = this.sheetContent;
    const destination = localNavigation();

    if (source) {
      delete source.dataset.filterId;
      delete source.dataset.tsLabels;
    }

    if (this.sheet) {
      this.sheet?.removeEventListener("oc-sheet-before-close", this.onClose);
    }

    moveAllChildren(source, destination);
  }

  /*       */

  private onClose = () => {
    this.deactivate();
    eventQBus.emit("ftfind.filterSheet.closedNavigation");
  };

  private static prepareContent(content: HTMLElement) {
    content.scrollTop = 0;
    content.dataset.filterId = LOCAL_NAVIGATION;

    setLegacyLabels(content, {
      san_FilterFoldoutType: LOCAL_NAVIGATION,
      san_FilterFoldoutActivity: "close",
      san_FacetChangeNothing: "view_selection",
    });
  }
}
